import React, { FC } from 'react';

import { Icon } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';

import MenuSectionHeading from 'components/menu-section-heading';
import { RecentItems } from 'components/recent-items';
import useEffectOnce from 'hooks/use-effect-once';
import { useRecentItemsAvailable } from 'hooks/use-recent-items-available';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';
import { routes } from 'utils/routing';

import { HeaderLink, HeaderTextWrapper, IconWrapper, RecentItemsContainer } from './styled';

export const RecentItemsSection: FC = () => {
  const showRecentItems = useFlag(LaunchDarklyFlag.ENABLE_HOME_PAGE_RECENT_ITEMS);
  const { formatMessage } = useIntl();
  const mParticle = useMParticleContext();

  const shouldShow = useRecentItemsAvailable();
  const locationName = 'Home page';
  const shouldDisplayRecentItems = showRecentItems && shouldShow;

  useEffectOnce(() => {
    if (shouldDisplayRecentItems) {
      mParticle.logEvent(CustomEventNames.RECENT_ITEMS_DISPLAYED, EventTypes.UserContent, {
        'User Location': locationName,
      });
    }
  });

  if (shouldDisplayRecentItems) {
    return (
      <RecentItemsContainer data-testid="recentItemsContainer">
        <MenuSectionHeading as="h2">
          <HeaderTextWrapper>
            {formatMessage({ id: 'yourFavorites' })}
            <HeaderLink to={routes.orders}>
              {formatMessage({ id: 'viewAll' })}
              <IconWrapper>
                <Icon icon="arrowRight" color="primary" width="0.6em" />
              </IconWrapper>
            </HeaderLink>
          </HeaderTextWrapper>
        </MenuSectionHeading>

        <RecentItems locationName={locationName} />
      </RecentItemsContainer>
    );
  }
  return null;
};
